export default function debounce (fn, wait) {
  let timer
  let lastArgs
  let lastContext
  const debounced = function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    lastContext = this
    lastArgs = args
    timer = setTimeout(() => {
      fn.apply(lastContext, lastArgs)
      timer = null
      lastArgs = null
      lastContext = null
    }, wait)
  }
  debounced.cancel = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
      lastArgs = null
      lastContext = null
    }
  }
  debounced.flush = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
      if (lastArgs != null) {
        fn.apply(lastContext, lastArgs)
      }
      lastArgs = null
      lastContext = null
    }
  }

  return debounced
}
